export const jobsTranslations = {
  JOBS_TITLE: 'Werken bij Tranzer?',
  JOBS_SUBTITLE: 'Versterk ons dreamteam!',

  JOB_OFFER_HEADER: 'Vacature',
  JOB_OFFER_READ_MORE: 'Lees meer',
};
